import { ExperienceType } from '@pflegia/types/common/candidate/experience-type';

export enum DociaEmployerType {
  Hospital = 'hospital',
  UniversityHospital = 'university_hospital',
  MedicalCareCenter = 'medical_care_center',
  OutpatientPractice = 'outpatient_practice',
  Dental = 'dental',
  RehabilitationClinic = 'rehabilitation_clinic',
  PrivateClinic = 'private_clinic',
  Any = 'any',
}

/** `Any` is a candidate job-search preference ("no specific type"), not a real employer category, so it's excluded from work history's employer type options. */
export const DOCIA_WORK_HISTORY_EMPLOYER_TYPES = Object.values(DociaEmployerType).filter(value => value !== DociaEmployerType.Any);

export type DociaWorkHistoryEmployerType = Exclude<DociaEmployerType, DociaEmployerType.Any>;

/**
 * All employer types a work history entry can have (Pflegia + Docia, minus the `Any` preference value).
 * The candidate self-service UI must offer every value the admin side can set on a work history, or a
 * candidate whose history was edited in the CRM with a Docia employer type gets stuck unable to save.
 */
export const WORK_HISTORY_EMPLOYER_TYPES: Record<string, ExperienceType | DociaWorkHistoryEmployerType> = {
  ...ExperienceType,
  ...DOCIA_WORK_HISTORY_EMPLOYER_TYPES.reduce<Record<string, DociaWorkHistoryEmployerType>>((acc, value) => {
    acc[value] = value;
    return acc;
  }, {}),
};
